import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import "./Modal.css"

const Modal = () => {
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    // eslint-disable-next-line no-undef
    var stripe = Stripe("pk_live_rkPDj53EXOgqXValWGlijLlb")

    var checkoutButton = document.getElementById(
      "checkout-button-sku_Fans6GH2XPnLQC"
    )
    checkoutButton.addEventListener("click", function() {
      setIsLoading(true)

      // When the customer clicks on the button, redirect
      // them to Checkout.
      stripe
        .redirectToCheckout({
          items: [{ sku: "sku_Fans6GH2XPnLQC", quantity: 1 }],

          // Do not rely on the redirect to the successUrl for fulfilling
          // purchases, customers may not always reach the success_url after
          // a successful payment.
          // Instead use one of the strategies described in
          // https://stripe.com/docs/payments/checkout/fulfillment
          successUrl: "http://www.robbiepearce.com/softies/payment",
          cancelUrl: "http://www.robbiepearce.com/softies/payment-failed.php"
        })
        .then(function(result) {
          if (result.error) {
            // If `redirectToCheckout` fails due to a browser or network
            // error, display the localized error message to your customer.
            var displayError = document.getElementById("error-message")
            displayError.textContent = result.error.message
          }
        })
        .finally(() => setIsLoading(false))
    })
  }, [])

  return (
    <div className="modal visible" data-content-name="package">
      <div className="content" id="donate">
        <Link to="/" className="close noshadow">
          Close popup
        </Link>

        <img
          src="images/files.png"
          className="files"
          alt="Download all icons"
        />
        <p>
          Download the whole package: Over <strong>400 SVGs</strong>, three
          sizes of <strong>PNGs</strong>, an <strong>IconJar</strong> file and
          the <strong>Sketch source file.</strong>
          <br />
          Yours to use personally and commercially for whatever you want.
        </p>

        <button
          id="checkout-button-sku_Fans6GH2XPnLQC"
          className="stripe-button"
        >
          {isLoading ? "Loading, please wait..." : "Buy now for £5"}
        </button>
      </div>
    </div>
  )
}

export default Modal
